import React from "react";
import { useTranslation } from "react-i18next";

import { getHelpArticleUrl } from "../../helpers/helpCenter";

interface HelpArticleLinkProps {
  articlePath: string;
  className?: string;
  label?: string;
  showIcon?: boolean;
}

const HelpArticleLink: React.FC<HelpArticleLinkProps> = ({
  articlePath,
  className = "",
  label,
  showIcon = true,
}) => {
  const { t, i18n } = useTranslation();

  return (
    <a
      href={getHelpArticleUrl(articlePath, i18n.language)}
      target="_blank"
      rel="noopener noreferrer"
      className={`text-muted text-decoration-none d-inline-flex align-items-center gap-1 ${className}`.trim()}
    >
      {showIcon ? <i className="ri-question-line" aria-hidden="true" /> : null}
      <span>{label ?? t("help.articleLink")}</span>
      <i className="ri-external-link-line fs-12" aria-hidden="true" />
    </a>
  );
};

export default HelpArticleLink;
